import Cookies from 'js-cookie'

export default class RegistrationFence {
  constructor ($el) {
    this.$el = $el
    this.url = $el.data('url')
    this.addEventHandlers()
    this.open()
  }

  addEventHandlers () {
    this.$el.on('click', '.js-registration-fence-close', this.onClose.bind(this))
    this.$el.on('click', '.js-registration-fence-overlay', this.onOverlayClick.bind(this))
    this.$el.on('click', '.js-registration-fence-submit', this.onSubmit.bind(this))
    EventBus.on('registration_fence:open', (_event, url) => this.open(0, url))
  }

  onClose () {
    this.$el.fadeOut()
    Cookies.set('registration_fence_uneligible', 'true', { expires: 2, path: '/' })
    EventBus.trigger('registration_fence:closed', true)
  }

  onOverlayClick ($event) {
    if ($event.currentTarget === $event.target) {
      $('.js-registration-fence-close', this.$el).click()
    }
  }

  onSubmit ($event) {
    $event.preventDefault()

    const $form = $('.js-registration-fence-form', this.$el)
    $.ajax({
      method: 'POST',
      url: $form.attr('action'),
      data: $form.serialize(),
      dataType: 'json'
    }).success((response) => {
      $(this.$el).html(response.body)

      EventBus.trigger('tracking:registrationSuccess', { pixelsConfig: response.webtrekk })
      Cookies.set('registration_fence_uneligible', 'true', { expires: 2, path: '/' })
    }).error((xhr) => {
      if (xhr.status === 400) {
        $(this.$el).html(xhr.responseJSON.body)
      }
    })
  }

  open (delay = 2000, url) {
    $.get(url || this.url, (data) => {
      this.$el.hide()
      this.$el.html(data)
      this.$el.delay(delay).fadeIn(() => {
        EventBus.trigger('tracking:manualEventTrack', { action_type: 'appear', $elem: this.$el.children().first() })
        EventBus.trigger('registration_fence:opened', true)
      })

      $('.input--login', this.$el).focus()
    })
  }
}

export const bind = () => {
  const $elem = $('.js-registration-fence')
  if ($elem.length > 0) {
    new RegistrationFence($('.js-registration-fence'))
  }
}

bind()
